import { EditRoles } from 'components/ui/roles/EditRoles';

export default EditRoles;
